import React from 'react';
import AdGuard from './AdGuard';

const About = () => {
  return (
    <div style={{ maxWidth: '800px', margin: '50px auto', padding: '20px', fontFamily: 'Arial, sans-serif', lineHeight: '1.8', color: '#333' }}>
      <h1 style={{ borderBottom: '2px solid #007bff', paddingBottom: '10px' }}>About PDFBlink</h1>
      
      <p>
        Welcome to <strong>PDFBlink</strong>, a professional platform dedicated to high-performance document management. 
        This site was founded and is maintained by a Full-Stack .NET Developer with over <strong>13 years of experience</strong> in the IT industry.
      </p>

      <h2>Our Expertise</h2>
      <p>
        With a career deeply rooted in the <strong>Banking, Financial Services, and Insurance (BFSI)</strong> domain, I have spent over a decade building secure, enterprise-grade applications. 
        I created PDFBlink to bring that same level of efficiency and security to everyday users who need to merge, compress, or split PDF files quickly and safely.
      </p>

      <h2>Why Trust PDFBlink?</h2>
      <ul>
        <li style={{ marginBottom: '10px' }}>
          <strong>Experience-Driven:</strong> Built with the technical knowledge gained from 13 years of software development in demanding financial sectors.
        </li>
        <li style={{ marginBottom: '10px' }}>
          <strong>Privacy-Focused:</strong> I have designed this tool to be privacy-first—ensuring your files are processed securely and deleted automatically.
        </li>
        <li style={{ marginBottom: '10px' }}>
          <strong>Built for the Community:</strong> Whether you are a student preparing for <strong>TNPSC exams</strong> or a remote professional, these tools are free and optimized for your success.
        </li>
      </ul>

      <h2>Our Commitment</h2>
      <p>
        Every tool on PDFBlink, from our <strong>Merge PDF</strong> utility to our <strong>Compressor</strong>, is engineered to provide high-quality results without the need for expensive software. 
        Thank you for choosing a tool built on over a decade of technical passion and expertise.
      </p>

      <div style={{ marginTop: '40px', padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px', textAlign: 'center', fontStyle: 'italic' }}>
        "Engineered with 13 years of experience in IT to deliver secure, high-performance PDF solutions."
      </div>
    </div>
  );
};

export default About;
